
import $ from 'jquery';
require('nanoscroller');

/**
 * Move nanoScroller to the target element's position. If an offset is 
 * defined, scrolls that amount higher than the target element.
 * 
 * @param {*} target - DOMNode or jQuery Object
 * @param {Number} offset
 */
function moveToContent(target, offset = 0) {
	const pos = $(target).offset().top;
	$('#container').find('.nano-content').animate({ scrollTop: pos - offset });
}


let isInited;

/**
 * Init nanoScrollers.
 */
function initScrollbars() {
	if (isInited) return;
	isInited = true;

	$('.nano').nanoScroller({ iOSNativeScrolling: true });
}

export default {
	/**
	 * Init nanoScrollers
	 */
	init() {
		initScrollbars();
	},

	/**
	 * Refreshes nanoScrollers
	 */
	refresh() {
		$('.nano').nanoScroller({ iOSNativeScrolling: true });
	},
	moveToContent,
};
